// extracted by mini-css-extract-plugin
export default {"slideshowAside":"slideshowAside_slideshowAside__dec8Y","asideControl":"slideshowAside_asideControl__dD1jt","collapsed":"slideshowAside_collapsed__axanI"};